import { parse, format, setGlobalDateI18n, defaultI18n } from 'fecha';
/**
 * @ngdoc service
 * @description
 * # dateLocaleFormatter
 * Formats a date according to selected language and formatInternet.
 */
export function formatDate(date, selectedFormat, language) {
    let formattedDate = '';
    if (date) {
        if (typeof date === 'object') {
            date = date.getTime();
        }
        date = setBelgiumTimezone(date);
        setLocale(language);
        formattedDate = format(date, selectedFormat);
        if (selectedFormat === 'MMM') {
            formattedDate = ucFirst(formattedDate.substring(0, 3));
        }
    }
    return formattedDate;
}
export function parseDate(dateString, parseFormat) {
    const result = parse(dateString, parseFormat);
    return result === null ? false : result;
}
function setLocale(language) {
    // english is the default in any case so we don't do anything..
    // Values are taken from fecha-locales, the library itself is not used here as it works through global scope
    switch (language) {
        case 'nl':
            setGlobalDateI18n({
                amPm: ['am', 'pm'],
                DoFn: (num) => num + (num === 1 || num === 8 || num >= 20 ? 'ste' : 'de'),
                dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
                dayNamesShort: ['zo.', 'ma.', 'di.', 'wo.', 'do.', 'vr.', 'za.'],
                monthNames: [
                    'januari',
                    'februari',
                    'maart',
                    'april',
                    'mei',
                    'juni',
                    'juli',
                    'augustus',
                    'september',
                    'oktober',
                    'november',
                    'december',
                ],
                monthNamesShort: [
                    'jan.',
                    'feb.',
                    'maart',
                    'apr.',
                    'mei',
                    'juni',
                    'juli',
                    'aug.',
                    'sept.',
                    'okt.',
                    'nov.',
                    'dec.',
                ],
            });
            break;
        case 'fr':
            setGlobalDateI18n({
                amPm: ['am', 'pm'],
                DoFn: (num) => num + (num === 1 ? 'er' : ''),
                dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
                dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
                monthNames: [
                    'janvier',
                    'février',
                    'mars',
                    'avril',
                    'mai',
                    'juin',
                    'juillet',
                    'août',
                    'septembre',
                    'octobre',
                    'novembre',
                    'décembre',
                ],
                monthNamesShort: [
                    'janv.',
                    'févr.',
                    'mars',
                    'avr.',
                    'mai',
                    'juin',
                    'juil.',
                    'août',
                    'sept.',
                    'oct.',
                    'nov.',
                    'déc.',
                ],
            });
            break;
        case 'de':
            setGlobalDateI18n({
                amPm: ['am', 'pm'],
                DoFn: (num) => num + (num >= 20 ? 'ste' : 'te'),
                dayNames: ['Soontag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                dayNamesShort: ['so.', 'mo.', 'di.', 'mi.', 'do.', 'fr.', 'sa.'],
                monthNames: [
                    'Januar',
                    'Februar',
                    'März',
                    'April',
                    'Mai',
                    'Juni',
                    'Juli',
                    'August',
                    'September',
                    'Oktober',
                    'November',
                    'Dezember',
                ],
                monthNamesShort: [
                    'jan.',
                    'feb.',
                    'märz',
                    'apr.',
                    'mai',
                    'juni',
                    'juli',
                    'aug.',
                    'sept.',
                    'okt.',
                    'nov.',
                    'dez.',
                ],
            });
            break;
        default:
            setGlobalDateI18n(defaultI18n);
            break;
    }
}
function setBelgiumTimezone(date) {
    const isDaylightSavings = (dayLightSavingsDate) => {
        const jan = new Date(dayLightSavingsDate.getFullYear(), 0, 1);
        const jul = new Date(dayLightSavingsDate.getFullYear(), 6, 1);
        return (dayLightSavingsDate.getTimezoneOffset() <
            Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()));
    };
    const dateObj = new Date(date);
    const userOffset = dateObj.getTimezoneOffset() * 60000;
    const belgiumOffset = (isDaylightSavings(dateObj) ? 2 : 1) * 60 * 60000; // GMT+1 or GMT+2
    return new Date(date + userOffset + belgiumOffset);
}
function ucFirst(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
